import {  VERIFY_TOKEN } from "../actions/actionTypes";
import { verifyTokenMutation } from "../../api/graphql/queries/authentication";
import graphqlClient from "../../api/axios_interceptor";
import { updateActionErrors } from "./updateErrors";
import { CustomLocalStorage, TOKEN_KEYS } from "../../utils/customStorage";
const verifyTokenMiddleware  = storeAPI => next =>async action => {

    switch(action.type){
        case VERIFY_TOKEN:
            let token = await CustomLocalStorage.getItem(TOKEN_KEYS.ACCESS);
            try {
                await graphqlClient({
                    data: {
                        query: verifyTokenMutation(token)
                    }
                    }).then((queryResult) => {
                        if (queryResult.data.errors) {
                            action = updateActionErrors(action, queryResult.data.errors);
                        } else if (queryResult.data.data.verifyToken.success === true) {
                            action.payload = true;
                        }else{
                            action.payload = false;
                        }
                });
            } catch (error) {
                console.error(error);
                action.payload = false;
            }
            break;    
    }
    
    return next(action);
};

export {
    verifyTokenMiddleware
}